import React, { useEffect,useState,useContext } from "react";
import Starback from "starback";
import {ThemeContext} from '../theme.context';

const CanvasLayer = () => {
  const [canvasHeight,setCanvasHeight] = useState(0);

  const {darkMode} = useContext(ThemeContext);
  useEffect(()=>{
    const hi = window.innerHeight;
    const wi = window.innerWidth;

    if(wi>1200){
      setCanvasHeight(hi*10);
    }
    else if(wi >900){
      setCanvasHeight(hi*8);
    }
    else if(wi>600){
      setCanvasHeight(hi*9);
    }else{
      setCanvasHeight(hi*9);
    }

  },[])

  useEffect(() => {
    const canvas = document.getElementById("canvas");
    const wi = window.innerWidth;
    const hi = canvasHeight;
    const color = darkMode?"#FF3B81":"#3957D2"
    const starback = new Starback(canvas, {
      width: wi,
      height: hi,
      // type: "dot",
      type: "dot",
      quantity: 300,
      starSize: [1, 4],
      direction: 20,
      starColor: "white",
      randomOpacity: [0.7, 1],
      backgroundColor: "transparent",
      // quantity: 100,
      // direction: 0,
      backgroundColor: [color], //"#223CA5",
      // randomOpacity: true,
    });
  }, [canvasHeight,darkMode]);
  return (
    <div>
      <canvas id="canvas" style={{height:'fit-content'}}></canvas>
    </div>
  );
};

export default CanvasLayer;
